module.exports = __webpack_public_path__ + "media/images/map/dollar-8d1c46c853219bd70112826f221bd397.svg";